import * as types from "../Action/type";

const initialState = {
    assignedRules: []
}
const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case types.FETCH_ASSIGN_SUCCESS:
            return {
                ...state,
                assignedRules: action.payload,
            };
        
        default:
            return state;
    }

}
export default AuthReducer;